var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-12"},[_c('v-icon',{staticClass:"spinner mx-3",attrs:{"size":"50"}},[_vm._v("fa fa-spinner")]),_c('p',{staticClass:"mt-5 ml-3 title grey--text text--darken-2"},[_vm._t("default",function(){return [_vm._v("Loading...")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }